import { render } from "./RoomPopup.vue?vue&type=template&id=0159d9e5&scoped=true"
import script from "./RoomPopup.vue?vue&type=script&lang=js"
export * from "./RoomPopup.vue?vue&type=script&lang=js"

import "./RoomPopup.vue?vue&type=style&index=0&id=0159d9e5&scoped=true&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0159d9e5"]])

export default __exports__